import React from 'react';
import { T } from 'app/components/localization';
import { LessonStudent, User } from 'app/constants/schemas';

type UserLike = LessonStudent | User;

const GetDisplayName: React.FunctionComponent<{
  children: (getName: (userLike: UserLike) => string) => React.ReactNode,
}> = ({ children }) => (
  <T>{t =>
    children(
      (userLike) => {
        if ('deletedAt' in userLike && userLike.deletedAt) {
          return t('page.users.display-name.deleted');
        } else {
          const email = 'email' in userLike ? userLike.email : null;

          return userLike.displayName || email || t('page.users.display-name.fallback');
        }
      },
    ) as React.ReactElement<any>
  }</T>
);

export default GetDisplayName;
